<template>
  <div
    :class="{
      active: value !== '',
      'multiselect__error multiselect__error--wrapper  ': hasError
    }"
  >
    <label
      v-if="showTitle"
      class="text-sm md:text-base font-normal text-gray-main mb-2 md:mb-3 block"
    >
      {{ title }}
    </label>
    <multiselect
      :value="value"
      :class="[$attrs.class, size, { 'multiselect__error multiselect__error--input  ': hasError, 'multiselect__modal': isModal }]"
      :placeholder="holder"
      :group-values="groupValues"
      :group-label="groupLabel"
      :max-height="maxHeight"
      :options="options"
      :searchable="searchAble"
      :label="_label"
      :internal-search="internalSearchLocal"
      :disabled="isDisabled"
      select-label=""
      selected-label=""
      deselect-label=""
      :allow-empty="allowEmpty"
      v-bind="$attrs"
      track-by="id"
      :loading="isLoading"
      :group-select="groupSelect"
      :multiple="multiple"
      @close="close"
      @open="open"
      @input="updateValue"
      @select="($event) => $emit('select', $event)"
      @search-change="asyncFind"
    >
      <!--      :multiple="true"
      :max="1"-->
      <span
        slot="tag"
        slot-scope="{option, remove}"
        class="multiselect__badge"
      >
        <AppBadge :text="option.name">
          <template #close>
            <div class="pr-3">
              <AppIcon
                name="close-circle"
                size="small"
                @click.native="remove(option)"
              />
            </div>
          </template>
        </AppBadge>
      </span>
      <span slot="noOptions">
        {{ $t("no_options_server") }}
      </span>
      <span slot="noResult">
        {{ $t("no_options_list") }}
      </span>
      <span
        slot="caret"
        slot-scope="{ toggle }"
        class="multiselect-arrow"
        @mousedown.prevent.stop="toggle"
      >
        <AppIcon
          name="chevron-down"
          color="text-gray-main"
        />
      </span>
      <template
        v-if="isModal"
        slot="option"
        slot-scope="props"
      >
        <div class="option__desc text-gray-medium">
          <InputRadio
            :id="props.option.key"
            size="md"
            :label="props.option.name"
            :model-value="props.option.key"
            :value="value && value.key"
            :name="`name-${props.option.name}`"
            :is-disable="true"
          />
        </div>
      </template>
    </multiselect>
    <span
      v-if="!isHiddenError && (serverError || error)"
      class="multiselect__error multiselect__error--text"
    >
      <template v-if="!serverError && error">
        {{ $t(`forms.${$attrs.name}.errors.${error}`) }}
      </template>
      <template v-if="serverError">
        {{ serverError }}
      </template>
    </span>
  </div>
</template>

<script>
import AppIcon from '@library/element/icon'
import InputRadio from '@library/element/input/input-radio.vue'
import AppBadge from '@library/element/badge'

export default {
  name: 'SelectBox',
  components: { AppBadge, AppIcon, InputRadio },
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'update'
  },
  props: {
    searchAble: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    internalSearch: {
      type: Boolean,
      default: true
    },
    groupValues: {
      type: String,
      default: ''
    },
    groupLabel: {
      type: String,
      default: ''
    },
    maxHeight: {
      type: Number,
      default: 300
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    groupSelect: {
      type: Boolean,
      default: false
    },
    isHiddenError: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md'
    },
    label: {
      type: String,
      default: ''
    },
    labelObject: {
      type: String,
      default: ''
    },
    holder: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    value: {
      type: [Object, Array, String],
      default: () => {
      }
    },

    options: {
      type: Array,
      default: () => {
      }
    },
    error: {
      type: String,
      default: null
    },
    serverError: {
      type: String,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isModal: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    allowEmpty: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isDelayed: false,
      thisVal: null
    }
  },
  computed: {
    hasError () {
      return !!(this.error || this.serverError)
    },
    _label () {
      return this.label || this.labelObject
    },
    internalSearchLocal () {
      return this.internalSearch && this.isDelayed
    }
  },
  methods: {
    updateValue (value) {
      this.$emit('update', value)
    },
    asyncFind (query) {
      if (query.length < 2) {
        this.isDelayed = false
        return false
      }
      this.isDelayed = true
      this.$emit('search', query)
    },
    open () {
      this.$store.commit('SET_STATE_BTN_CALL', true)
    },
    close () {
      this.$store.commit('SET_STATE_BTN_CALL', false)
    }
  }
}
</script>
<style src="./vue-multiselect.scss" lang="scss"></style>
